// Ported from the validated lesson-planner engine (index.html SPECIAL_TOPICS,
// lines 1081-1130 as of 2026-08-14) — key/label only; the actual grammar/vocab
// tier content is resolved server-side (backend/curriculum_data.py).
export const SPECIAL_TOPICS = [
  { key: "modals", label: "Modal verbs" },
  { key: "phrasalverbs", label: "Phrasal verbs" },
  { key: "passive", label: "Passive Voice" },
  { key: "reportedspeech", label: "Reported Speech" },
  { key: "conditionals", label: "Conditionals" },
  { key: "relativeclauses", label: "Relative Clauses" },
  { key: "comparatives", label: "Comparatives & Superlatives" },
  { key: "questionformation", label: "Question Formation" },
  { key: "irregularverbs", label: "Irregular Verbs" },
  { key: "vocabbuilding", label: "Vocabulary Building" },
  { key: "tensesrun", label: "Tenses Run-through" },
  { key: "mocktest", label: "Mock Test" },
  { key: "phonetics", label: "Pronunciation & Phonetics" },
];
